import { render, staticRenderFns } from "./ByProductForm.vue?vue&type=template&id=516cbace&"
import script from "./ByProductForm.vue?vue&type=script&lang=js&"
export * from "./ByProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports